import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  directPrintShipmentGridPackingSlips,
  downloadShipmentGridPackingSlips,
  printShipmentGridPackingSlips,
} from '../../../../store/shipments/grid/shipments.grid.actions';
import { printPackingSlip } from '../../../../store/printing/print.actions';

export const usePackingSlip = ({ fulfillments }) => {
  const dispatch = useDispatch();
  const isDisabled = fulfillments.length === 0;
  const fulfillmentPlanIds = useMemo(() => fulfillments.map((f) => f.fulfillmentPlanId), [fulfillments]);
  const onClick = useCallback(() => {
    const hasPrintedPackingSlip = fulfillments.some((plan) => plan.isPackingSlipPrinted);
    if (fulfillmentPlanIds.length === 1) {
      dispatch(printPackingSlip(fulfillmentPlanIds, hasPrintedPackingSlip, false, false));
    } else {
      dispatch(printShipmentGridPackingSlips(false));
    }
  }, [dispatch, fulfillmentPlanIds, fulfillments]);
  const onDownload = useCallback(() => {
    dispatch(downloadShipmentGridPackingSlips());
  }, [dispatch]);
  const onPrint = useCallback(() => {
    dispatch(directPrintShipmentGridPackingSlips());
  }, [dispatch]);

  return useMemo(
    () => ({
      isDisabled,
      onClick,
      onDownload,
      onPrint,
    }),
    [isDisabled, onClick, onDownload, onPrint],
  );
};
